import { isInternationalTheme } from "config/ConfigUtils";

/**
 * Suite Events — uygulama (frontend) tarafı funnel takibi.
 *
 * ÖNEMLİ: Sadece uluslararası (routebot) tema için çalışır. Servistesin/filokar
 * kullanıcılarında HİÇBİR event gönderilmez — mevcut kullanıcı hiçbir şey fark etmez.
 *
 * navigator.sendBeacon ile non-blocking, fire-and-forget gönderim yapar; UI'ı asla
 * bloklamaz. Gövde text/plain olarak yollanır (CORS preflight'tan kaçınmak için);
 * backend bunu JSON olarak parse eder.
 */

const ENDPOINT = `${process.env.REACT_APP_BACKEND_URL}/suite-events`;
const SESSION_KEY = "rb_app_session_id";

const getSessionId = () => {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id =
        typeof crypto !== "undefined" && crypto.randomUUID
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return undefined;
  }
};

/**
 * @param {string} name  Anlaşılır olay adı, örn: "Subscription — Upgrade to PRO"
 * @param {"button_click"|"modal_view"|"page_view"|"other"} [type]
 * @param {object} [meta]
 */
export const trackSuiteEvent = (name, type = "button_click", meta = {}) => {
  try {
    // Servistesin/filokar kullanıcısını ASLA etkileme.
    if (typeof window === "undefined" || !name) return;
    if (!isInternationalTheme()) return;

    const payload = JSON.stringify({
      source: "app",
      type,
      name,
      path: window.location.pathname,
      pageUrl: window.location.href,
      meta: meta || {},
      sessionId: getSessionId(),
    });

    const blob = new Blob([payload], { type: "text/plain;charset=UTF-8" });

    if (navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, blob)) {
      return;
    }

    fetch(ENDPOINT, {
      method: "POST",
      body: payload,
      headers: { "Content-Type": "text/plain;charset=UTF-8" },
      keepalive: true,
      mode: "cors",
    }).catch(() => {});
  } catch {
    // analytics asla UI'ı kırmamalı
  }
};
